import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
type CTAButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
};
export function CTAButton({
  children,
  size = 'lg',
  className = '',
  href = '#get-access'
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-sm sm:px-8 sm:text-base' : 'px-5 py-3.5 text-[13px] sm:text-sm';
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#')) {
      trackPixelEvent('InitiateCheckout', {
        value: 24,
        currency: 'USD'
      });
      return;
    }
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex max-w-full items-center justify-center gap-3 rounded-lg bg-brand-gold text-center font-extrabold uppercase leading-snug tracking-wide text-navy-900 shadow-cta transition-[background-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:bg-brand-goldDark hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-gold active:translate-y-0 ${sizing} ${className}`} style={{
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "15px",
    paddingRight: "15px",
    backgroundColor: "#FFF200",
    backgroundImage: "none"
  }} data-id="element-12" data-mp="38m5zi8mewcyb">
      <span className="min-w-0 break-words" style={{
      fontSize: "20px"
    }} data-id="element-13" data-mp="210m6ziq3aqdp">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="hidden h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" data-id="element-14" data-mp="25yno3y3ygfmj" />
    </a>;
}